import React, { useState } from "react";

const ImageSlider = ({ images }) => {
  console.log("images", images);
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="image-slider">
      <div
        // className="slider-container"
        style={{ display: "flex", flexDirection: "row" }}
      >
        <button
          onClick={prevSlide}
          //   className="slider-button left"
          style={{
            height: 50,
            width: 50,
            backgroundColor: "white",
            position: "absolute",
            top: "55%",
            borderRadius: 50 / 2,
          }}
        >
          &lt;
        </button>
        <img
          src={images.length > 0 ? images[currentIndex].carImageUrl : null}
          //   alt="Slider"
          className="w-100"
        />
        <button
          onClick={nextSlide}
          style={{
            height: 50,
            width: 50,
            backgroundColor: "white",
            position: "absolute",
            top: "55%",
            left: "45%",
            alignSelf: "flex-end",

            borderRadius: 50 / 2,
          }}
        >
          &gt;
        </button>
      </div>
    </div>
  );
};

export default ImageSlider;
